import { create } from 'zustand';

interface VariationCreatorStoreState {
  isOpen: boolean;
  postId: number | undefined;
  variationId: number | undefined;
  initialScheduleOpen: boolean;
}

interface VariationCreatorStoreActions {
  open: (params: { postId: number; variationId?: number | null; initialScheduleOpen?: boolean }) => void;
  close: () => void;
}

type VariationCreatorStore = VariationCreatorStoreState & VariationCreatorStoreActions;

export const useVariationCreatorStore = create<VariationCreatorStore>((set) => ({
  isOpen: false,
  postId: undefined,
  variationId: undefined,
  initialScheduleOpen: false,
  open: ({ postId, variationId, initialScheduleOpen }) =>
    set({
      isOpen: true,
      postId,
      variationId: variationId ?? undefined,
      initialScheduleOpen: initialScheduleOpen ?? false,
    }),
  close: () =>
    set({ isOpen: false, postId: undefined, variationId: undefined, initialScheduleOpen: false }),
}));
